module.exports = __webpack_public_path__ + "img/s-hd.6021305e.jpg";